const checkAuth = function (response) {
	switch (response.status) {
		case 200:
			return response
		case 403:
			throw new Error('Not Authorized')
		case 500:
			throw new Error('Unable to contact service')
		default:
			throw new Error('Not Authorized')
	}
}

const getJson = function (response) {
	return response.json()
}

const checkStatus = (obj, response) => {
	const code = Object.keys(obj).find(element => response.status + '' === element + '')
	if (!code) {
		throw new Error('Unhandled Error during fetch' + response.status)
	}
	return obj[code](response)
}

const getBody = (login, parameter) => {
	return JSON.stringify(
		{
			role: 'ROLE_ADMIN_' + login,
			typeparameter: parameter
		})
}

export { checkAuth, getJson, checkStatus, getBody }



// WEBPACK FOOTER //
// ./src/utils/ActionUtils.js